// extracted by mini-css-extract-plugin
export default {"book-holds":"BookHolds_book-holds__oc8db"};